import Select from 'threads5/Select';
import FormControl from 'threads5/FormControl';
import InputLabel from 'threads5/InputLabel';
import type { ICareersSearchSelectFilterProps } from './CareersSearch.types';

const CareersSelectFilter = ({
  label,
  value,
  onChange,
  items,
  sx,
}: ICareersSearchSelectFilterProps) => {
  if (!Array.isArray(items) || items.length < 1) {
    return null;
  }
  const idPrefix = label.toLowerCase();
  return (
    <FormControl
      id={`${idPrefix}-form-ctrl`}
      sx={{
        flexGrow: 1,
        width: {
          xs: '100%',
          md: 'auto',
        },
      }}
    >
      <InputLabel
        id={`${idPrefix}-label-id`}
        size={48}
        htmlFor={`${idPrefix}-select-id`}
      >
        {label}
      </InputLabel>
      <Select
        id={`${idPrefix}-select-id`}
        labelId={`${idPrefix}-label-id`}
        size={48}
        fullWidth={true}
        sx={{
          select: {
            ':focus': {
              border: 'none',
            },
          },
          ...sx,
        }}
        native
        value={value}
        onChange={onChange}
      >
        <option></option>
        {items.map((item) => {
          return (
            <option key={item} value={item}>
              {item}
            </option>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default CareersSelectFilter;
